import styled from 'styled-components';

const OrangeText = styled.span`
  color: #FF9704;
`;
export { OrangeText }